import * as io from 'io-ts';

export const EmbedProfileIO = io.union([
    io.literal('full-screen'),
    io.literal('simple'),
    io.literal('all-tools'),
    io.literal('fancy'),
]);
export type EmbedProfile = io.TypeOf<typeof EmbedProfileIO>;
